import React from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"

function TicketFoodPricing({ dietaryPreferences = [], audienceTicketData, validation }) {
  if (!audienceTicketData) return null

  const { audienceType, ageGroup, ticketBooking } = audienceTicketData

  // const showEarlyBird = ticketBooking?.earlyBird || false
  const showEarlyBird = Boolean(ticketBooking?.earlyBird)

  const ticketCategories = []

  if (ageGroup?.adult) {
    if (audienceType?.member) ticketCategories.push("Adult Member")
    if (audienceType?.nonMember) ticketCategories.push("Adult Non Member")
    // if (audienceType?.sponsor) ticketCategories.push("Adult Sponsor")
  }

  if (ageGroup?.child) {
    if (audienceType?.member) ticketCategories.push("Child Member")
    if (audienceType?.nonMember) ticketCategories.push("Child Non Member")
    // if (audienceType?.sponsor) ticketCategories.push("Child Sponsor")
  }

  return (
    <>
      {/* Ticket Pricing */}
      <Row className="mb-5">
        <div className="d-flex align-items-center mb-4">
          <div className="avatar-sm me-3">
            <span className="avatar-title rounded-circle bg-warning bg-soft text-warning font-size-18">
              <i className="mdi mdi-ticket-percent"></i>
            </span>
          </div>
          <div>
            <h5 className="mb-0 fw-semibold">Ticket Pricing Matrix</h5>
            <small className="text-muted">Set pricing per audience category</small>
          </div>
        </div>
        {ticketCategories.length === 0 ? (
          <div className="text-center py-4 text-muted">
            <i className="mdi mdi-account-off font-size-36 d-block mb-2"></i>
            No audience selected
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th className="fw-semibold">Category</th>
                  {showEarlyBird && <th className="fw-semibold text-warning"><i className="mdi mdi-bird me-1"></i>Early Bird Cost</th>}
                  <th className="fw-semibold text-primary">Standard Cost</th>
                </tr>
              </thead>
              <tbody>
                {ticketCategories.map(category => {
                  const catKey = category.toLowerCase().replace(/ /g, "_")
                  const earlyName = `ticketPricing.${catKey}.early`
                  const standardName = `ticketPricing.${catKey}.standard`
                  const earlyError = validation?.touched?.ticketPricing?.[catKey]?.early && validation?.errors?.ticketPricing?.[catKey]?.early
                  const standardError = validation?.touched?.ticketPricing?.[catKey]?.standard && validation?.errors?.ticketPricing?.[catKey]?.standard

                  return (
                    <tr key={category}>
                      <td><span className="badge bg-light text-dark border">{category}</span></td>
                      {showEarlyBird && (
                        <td>
                          <div className="input-group input-group-sm">
                            <span className="input-group-text bg-warning bg-soft text-warning">$</span>
                            <Input type="number" 
                                   min="0.01"
  step="0.01"
                            name={earlyName} value={validation.values?.ticketPricing?.[catKey]?.early || ""} 
                            
                            // onChange={validation.handleChange} 
                              onChange={(e) => {
                const val = e.target.value
                // FIX: Changed standardName to earlyName below
                if (val === "" || /^\d*\.?\d*$/.test(val)) {
                  validation.setFieldValue(earlyName, val)
                }
              }}
                            onBlur={validation.handleBlur} invalid={!!earlyError} placeholder="0.00" style={{ maxWidth: 140 }} />
                          </div>
                          {earlyError && <div className="text-danger small mt-1">{earlyError}</div>}
                        </td>
                      )}
                      <td>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-primary bg-soft text-primary">$</span>
                          <Input type="number" 
                                 min="0.01"
  step="0.01"
                          name={standardName} value={validation.values?.ticketPricing?.[catKey]?.standard || ""} 
                          // onChange={validation.handleChange} 
                           onChange={(e) => {
    const val = e.target.value

    // Allow typing like "0." or ""
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      validation.setFieldValue(standardName, val)
    }
  }}
                          onBlur={validation.handleBlur} invalid={!!standardError} placeholder="0.00" style={{ maxWidth: 140 }} />
                        </div>
                        {standardError && <div className="text-danger small mt-1">{standardError}</div>}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </Row>

      <Row>
        {/* Food Pricing */}
        <div className="d-flex align-items-center mb-4">
          <div className="avatar-sm me-3">
            <span className="avatar-title rounded-circle bg-success bg-soft text-success font-size-18">
              <i className="mdi mdi-food"></i>
            </span>
          </div>
          <div>
            <h5 className="mb-0 fw-semibold">Food Pricing Matrix</h5>
            <small className="text-muted">Set pricing per food type and audience category</small>
          </div>
        </div>

        {dietaryPreferences.length === 0 ? (
          <div className="text-center py-4 text-muted">
            <i className="mdi mdi-food-off font-size-36 d-block mb-2"></i>
            No food category selected
          </div>
        ) : ticketCategories.length === 0 ? (
          <div className="text-center py-4 text-muted">
            <i className="mdi mdi-account-off font-size-36 d-block mb-2"></i>
            No audience selected
          </div>
        ) : (
          <div className="d-flex flex-column gap-4">
            {dietaryPreferences.map(foodType => {
              const badgeColor = foodType === "Veg" ? "success" : foodType === "Non-Veg" ? "danger" : "info"

              return (
                <div key={foodType}>
                  <div className="d-flex align-items-center mb-3">
                    <span className={`badge bg-${badgeColor} me-2`}>{foodType}</span>
                    <h6 className="mb-0 fw-semibold">Pricing</h6>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="fw-semibold">Category</th>
                          {showEarlyBird && <th className="fw-semibold text-warning"><i className="mdi mdi-bird me-1"></i>Early Bird Cost</th>}
                          <th className="fw-semibold text-primary">Standard Cost</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticketCategories.map(category => {
                          const foodKey = foodType.toLowerCase().replace(/-/g, "_")
                          const catKey = category.toLowerCase().replace(/ /g, "_")
                          const earlyName = `ticketFoodPricing.${foodKey}.${catKey}.early`
                          const standardName = `ticketFoodPricing.${foodKey}.${catKey}.standard`
                          const earlyError = validation?.touched?.ticketFoodPricing?.[foodKey]?.[catKey]?.early && validation?.errors?.ticketFoodPricing?.[foodKey]?.[catKey]?.early
                          const standardError = validation?.touched?.ticketFoodPricing?.[foodKey]?.[catKey]?.standard && validation?.errors?.ticketFoodPricing?.[foodKey]?.[catKey]?.standard

                          return (
                            <tr key={`${foodType}-${category}`}>
                              <td><span className="badge bg-light text-dark border">{category}</span></td>
                              {showEarlyBird && (
                                <td>
                                  <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-warning bg-soft text-warning">$</span>
                                    <Input type="number" 
                                           min="0.01"
  step="0.01"
                                    name={earlyName} value={validation.values?.ticketFoodPricing?.[foodKey]?.[catKey]?.early || ""}
                                    //  onChange={validation.handleChange} 
                                     onChange={(e) => {
                const val = e.target.value
                // FIX: Changed standardName to earlyName below
                if (val === "" || /^\d*\.?\d*$/.test(val)) {
                  validation.setFieldValue(earlyName, val)
                }
              }}

                                     onBlur={validation.handleBlur} invalid={!!earlyError} placeholder="0.00" style={{ maxWidth: 140 }} />
                                  </div>
                                  {earlyError && <div className="text-danger small mt-1">{earlyError}</div>}
                                </td>
                              )}
                              <td>
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text bg-primary bg-soft text-primary">$</span>
                                  <Input type="number" 
                                         min="0.01"
  step="0.01"
                                  name={standardName} value={validation.values?.ticketFoodPricing?.[foodKey]?.[catKey]?.standard || ""} 
                                  // onChange={validation.handleChange}
                                   onChange={(e) => {
    const val = e.target.value

    // Allow typing like "0." or ""
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      validation.setFieldValue(standardName, val)
    }
  }}
                                   onBlur={validation.handleBlur} invalid={!!standardError} placeholder="0.00" style={{ maxWidth: 140 }} />
                                </div>
                                {standardError && <div className="text-danger small mt-1">{standardError}</div>}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </Row>
    </>
  )
}

export default TicketFoodPricing
